import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import React, { memo, useState } from 'react';

import * as basePropTypes from 'src/constants/propTypes/base';

import ConfirmationModal from 'src/components/modals/Confirmation';
import LinkOutIcon from 'src/components/icons/LinkOut';
import SiteWideLinks from 'src/components/navigation/SiteWideLinks';

import styles from './styles.module.scss';

function AllFeaturedCollections(props) {
  const {
    addFeaturedCollection,
    collections,
    isActive,
    location,
  } = props;

  const [selectedId, setSelectedId] = useState(null);

  function openModal(id) {
    setSelectedId(id);
  }

  function closeModal() {
    setSelectedId(null);
  }

  function confirmAdd() {
    addFeaturedCollection({ id : selectedId });
  }

  const selectedCollection = selectedId ?
    collections.find(c => String(c.get('id')) === String(selectedId)) :
    null;

  return (
    <div className={ styles.Root } data-automated-test="featured-collections-page">
      <h1 className={ styles.Heading }>Learn Languages</h1>

      <p className={ styles.Intro }>
        Pick a language to add a curated bundle of study sets to your studies.
        { ' ' }
        Each bundle includes vocabulary, audio, and image exercises
        { ' ' }
        designed to help you memorize quickly.
      </p>

      <ul className={ styles.CardList }>
        <For each="collection" of={ collections.toJS ? collections.toJS() : collections }>
          <li key={ collection.id }>
            <div
              className={ styles.Card }
              data-automated-test={ `featured-collection-card-${collection.id}` }
              onClick={ () => openModal(collection.id) }
            >
              <h2 className={ styles.CardTitle }>{ collection.name }</h2>

              <If condition={ collection.description }>
                <p className={ styles.CardDescription }>{ collection.description }</p>
              </If>

              <p className={ styles.CardCount }>
                { (collection.studySets || []).length } study sets
              </p>
            </div>
          </li>
        </For>
      </ul>

      <If condition={ selectedCollection }>
        <ConfirmationModal
          closeModal={ closeModal }
          extraClasses={ { container : styles.ModalContainer } }
          isActive={ isActive }
          isPositiveAction
          submitAction={ confirmAdd }
          submitActionName="Add these to my study sets"
          title={ false }
        >
          <p className={ styles.ModalIntro }>
            { `You're about to add these ${selectedCollection.get('name')} study sets:` }
          </p>

          <ul className={ styles.ModalList }>
            <For each="set" of={ selectedCollection.get('studySets').toJS() }>
              <li className={ styles.ModalListItem } key={ set.id }>
                <Link
                  className={ styles.ModalListLink }
                  target="_blank"
                  to={ `/public-study-sets/${set.id}` }
                >
                  <span>{ set.title }</span>
                  <span className={ styles.ModalListIcon }><LinkOutIcon /></span>
                </Link>
              </li>
            </For>
          </ul>

          <p className={ styles.ModalNote }>
            Your first quiz on these will be ready tomorrow.
          </p>
        </ConfirmationModal>
      </If>

      <SiteWideLinks location={ location } />
    </div>
  );
}

AllFeaturedCollections.propTypes = {
  addFeaturedCollection : PropTypes.func.isRequired,
  collections           : PropTypes.object.isRequired,
  isActive              : PropTypes.bool,
  location              : basePropTypes.location.isRequired,
};

export default memo(AllFeaturedCollections);
